import PostPreview from 'Components/social-account/PostPreview'
import PostPreviewCreator from 'Components/social-account/PostPreviewCreator'
import CreatorCard from 'Components/social-account/SocialAccountCreators/CreatorCard'
import React, { useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Modal } from 'reactstrap'
import { removeFromCollectionAPI } from 'services/api/collection'
import { AppDispatch, RootState } from 'store'
import { SocialPost } from 'types/campaign/collaborations'
import { SocialAccount } from 'types/influencer'
import { SocialAccountCreator } from 'types/social-account'

const DeleteCollectionItemModal: React.FC<{ isOpen: boolean, onClose: () => void, post?: SocialPost | null, creator?: SocialAccount | null, collectionId?: string, onDelete?: () => void, itemType: 'post' | 'account' }> = ({ isOpen, onClose, post, creator, collectionId, onDelete, itemType }) => {
    const dispatch: AppDispatch = useDispatch();
    const selectedAgencyId = useSelector((state: RootState) => state.auth.selectedAgencyId);
    const [processing, setProcessing] = useState(false);


    const removeFromCollection = async () => {
        if (itemType === 'post' && !post) return;
        if (itemType === 'account' && !creator) return;
        const uuid = itemType === 'post' ? post?.uuid : creator?.uuid;
        if (!selectedAgencyId || !uuid) return;
        try {
            setProcessing(true);
            await removeFromCollectionAPI(selectedAgencyId, uuid, itemType, collectionId);
            if (onDelete) {
                await onDelete();
            }
        } catch (error) {
            console.log(error);
        } finally {
            setProcessing(false);
            onClose();
        }
    }

    return (
        <Modal isOpen={isOpen} toggle={onClose} centered className='manage-collection-item-modal-parent'>
            {
                <div className='manage-collection-item-modal'>
                    <div className="manage-collection-item-thumbnail-wrapper">
                        {
                            itemType === 'post' && post &&
                            <div className="manage-collection-item-thumbnail">
                                <PostPreview post={post} />
                                {
                                    post.social_account &&
                                    <div className="creator-details">
                                        <PostPreviewCreator socialAccount={post.social_account} />
                                    </div>
                                }
                            </div>
                        }
                        {
                            itemType === 'account' && creator &&
                            <div className="manage-collection-item-thumbnail creator">
                                <CreatorCard creator={{social_account: creator} as SocialAccountCreator} showOverlay={false} />
                            </div>
                        }
                    </div>
                    <h3 className="manage-collection-item-modal-title">
                        Are you sure you want to delete this?
                    </h3>
                    <div className="d-flex align-items-center justify-content-between w-100 gap-3">
                        <button className="btn btn-gradient-outline w-50" onClick={onClose}>
                            No
                        </button>
                        <button onClick={removeFromCollection} disabled={processing} className="btn btn-gradient w-50">
                            {
                                processing ? 'Please wait...' : "Yes, Delete"
                            }
                        </button>
                    </div>
                </div>
            }
        </Modal>
    )
}

export default DeleteCollectionItemModal